module.exports = __webpack_public_path__ + "media/Outdoor Tai Chis.7278b330.mp4";